import { RecipeVariants } from '@vanilla-extract/recipes';
import clsx from 'clsx';
import { ComponentPropsWithoutRef, forwardRef, PropsWithChildren } from 'react';
import { useColumnResizingContext } from 'src/contexts/ColumnResizingContext/ColumnResizingContext';
import { mergeProps } from 'src/core/utils';

import { DivWithTitle } from '../DivWithTitle';
import * as styles from './TableCellDiv.css';

export type TableCellDivProps = ComponentPropsWithoutRef<'div'> &
  PropsWithChildren<RecipeVariants<typeof styles.tableCellDivRecipe>> & {
    showTooltip?: boolean;
    tooltipVariant?: 'theme' | 'light' | 'dark' | 'darkGray';
    showTooltipArrow?: boolean;
    wrap?: 'wrap' | 'nowrap' | undefined;
    shouldHideCheckboxes?: boolean;
    customTooltipContent?: React.ReactNode;
  };

export const TableCellDiv = forwardRef<HTMLDivElement, TableCellDivProps>(
  function TableCellDiv(
    {
      align = 'left',
      overflowWrap,
      children,
      showTooltip,
      showTooltipArrow = true,
      tooltipVariant,
      title,
      wrap,
      shouldHideCheckboxes,
      customTooltipContent,
      ...props
    },
    ref
  ) {
    const { isResizeEnabled } = useColumnResizingContext();
    return (
      <DivWithTitle
        ref={ref}
        align={align}
        showTooltip={showTooltip}
        showTooltipArrow={showTooltipArrow}
        title={title}
        customTooltipContent={customTooltipContent}
        {...mergeProps(
          {
            className: clsx(
              styles.tableCellDivRecipe({
                align,
                overflowWrap,
                textWrap: wrap ? wrap : isResizeEnabled ? 'nowrap' : 'wrap',
              }),
              styles.tableCellDiv,
              { [styles.onHoverCheckbox]: shouldHideCheckboxes }
            ),
          },
          props
        )}
      >
        {children}
      </DivWithTitle>
    );
  }
);
